import React from 'react';
import styles from '../../../styles/components/warning-modal.scss';
import { useState, useEffect } from 'react';

const WarningModal = ({ visible, onOk, warningType, buttonText = "OK", title = "Vehicle Identification Warning" }) => {
  // const { t } = useTranslation();

	const t = (key) => key;


	const [isVisible, setIsVisible] = useState(visible)

  useEffect(() => {
    setIsVisible(visible)
  }, [visible])

  const handleClose = () => {
    setIsVisible(false)
    if (onOk) {
      onOk()
    }
  }

  if (!isVisible) return null

  const getWarningMessage = () => {
    let baseMessage = '';
    switch (warningType) {
      case 'AVN_VIN_MISMATCH':
        baseMessage = t('An Amazon Vehicle Number detected in this inspection does not match our records for this VIN.');
        break;
      case 'VLP_VIN_MISMATCH':
      case 'VLP_MATCH_OTHER_VIN':
        baseMessage = t('A license plate detected in this inspection does not match our records for this VIN.');
        break;
      default:
        baseMessage = t('There is a mismatch in the vehicle identification information.');
    }

    const supportMessage = t('If you are sure all photos are from the correct vehicle, please complete your inspection and email a video of the VIN and vehicle walk-around to support@pave.ai');

    return (
      <>
        <p>{baseMessage}</p>
        <p>{supportMessage}</p>
      </>
    );
  };

  return (
		<div className="modalOverlay">
		<div className="modalBackdrop" onClick={handleClose} />
		<div className="modalContainer">
			<div className='modalMessage'>{getWarningMessage()}</div>
			<button className='modalButton' onClick={handleClose}>
				{buttonText}
			</button>
		</div>
	</div>
  );
};

export default React.memo(WarningModal); 